(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getQueryHelpers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7328);
/* harmony import */ var clients_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3522);


/**
 * Get query helpers to query Sanity. This is necessary to make sure that the backend (for SSR)
 * and frontend (for Real-time preview), share the exact same querying code. This way, we are sure
 * the queries are built the exact same way.
 *
 * @param buildQuery A function used to build the query from the arguments passed, in case we
 * want to do any preprocessing using the args before returning the query. Usually, this should
 * not happen and the query should be using the args using parameters (e.g.) `$slug`).
 * @param initialArgs Arguments that should be supplied to the query but not needed to be passed
 * by `fetch` and `usePreviewSubscription`.
 */ var getQueryHelpers = function(buildQuery, initialArgs) {
    return {
        fetch: function(args, preview) {
            return (0,clients_sanity__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)(preview).fetch(buildQuery(), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, initialArgs, args));
        },
        usePreviewSubscription: function(initialData, args, preview) {
            return (0,clients_sanity__WEBPACK_IMPORTED_MODULE_0__/* .usePreviewSubscription */ .$r)(buildQuery(), {
                initialData: initialData,
                enabled: preview,
                params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, initialArgs, args)
            });
        }
    };
};


/***/ }),

/***/ 9382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R1": function() { return /* binding */ getPageWithSettingsQueryHelpers; },
/* harmony export */   "eS": function() { return /* binding */ getPageWithWebsiteQueryHelpers; },
/* harmony export */   "kn": function() { return /* binding */ getHomePageWithSettingsQueryHelpers; }
/* harmony export */ });
/* unused harmony export fetchPagesWithMinimalData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8788);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2228);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6711);
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_sanity__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var clients_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3522);
/* harmony import */ var _helpers_get_query_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3517);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        '*[_type == "page" && defined(slug.current)][].slug.current'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        '\n      *[_type == "page" && slug.current == $slug][0] {\n        _id,\n        _updatedAt,\n        title,\n        body,\n        "slug": slug.current,\n        "websiteSettings": *[_type == "websiteSettings"][0],\n      }\n    '
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        '\n      *[_type == "homePage" && _id == "homePage"][0] {\n        _id,\n        rollingText,\n        seo,\n        "websiteSettings": *[_type == "websiteSettings"][0],\n      }\n    '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        '*[_type == "websiteSettings"][0]'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var fetchPagesWithMinimalData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,clients_sanity__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)(false).fetch(next_sanity__WEBPACK_IMPORTED_MODULE_5___default()(_templateObject())));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPagesWithMinimalData() {
        return _ref.apply(this, arguments);
    };
}();
var getPageWithSettingsQueryHelpers = function() {
    return (0,_helpers_get_query_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getQueryHelpers */ .D)(function() {
        return next_sanity__WEBPACK_IMPORTED_MODULE_5___default()(_templateObject1());
    });
};
var getHomePageWithSettingsQueryHelpers = function() {
    return (0,_helpers_get_query_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getQueryHelpers */ .D)(function() {
        return next_sanity__WEBPACK_IMPORTED_MODULE_5___default()(_templateObject2());
    });
};
var getPageWithWebsiteQueryHelpers = function() {
    return (0,_helpers_get_query_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getQueryHelpers */ .D)(function() {
        return next_sanity__WEBPACK_IMPORTED_MODULE_5___default()(_templateObject3());
    });
};


/***/ }),

/***/ 4796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2123);
/* harmony import */ var data_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9382);
/* harmony import */ var components_layouts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(625);




var usePreviewSubscription = (0,data_page__WEBPACK_IMPORTED_MODULE_2__/* .getHomePageWithSettingsQueryHelpers */ .kn)().usePreviewSubscription;
var Home = function(param) {
    var data = param.data, preview = param.preview;
    var ref;
    var ref1 = usePreviewSubscription(data.homePage, {}, preview), home = ref1.data;
    if (!home) {
        throw new Error("Home page no longer exists!");
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layouts__WEBPACK_IMPORTED_MODULE_3__/* .MainLayout */ .Z, {
        settings: home.websiteSettings,
        ogImage: (ref = home.seo) === null || ref === void 0 ? void 0 : ref.image,
        path: "/",
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Hero */ .VM, {
                discordLink: home.websiteSettings.discord || "",
                rollingText: home.rollingText || ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Collaboration */ .mn, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Platforms */ .YK, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Expectations */ .FI, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Community */ .S1, {
                discordLink: home.websiteSettings.discord || "",
                background: "gray"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_1__/* .Newsletter */ .mA, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 2228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [525,747,106,625,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);